import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchRelatedProductsServices,
  NewArrivalServices,
  ProductServices,
  SpecificProductsServices,
} from "../services/productServices";

// Async thunk to fetch banners
export const fetchProductDetails = createAsyncThunk(
  "product/fetchProductDetails",
  async ({ shopId, lang }, { rejectWithValue }) => {
    try {
      const response = await ProductServices(shopId, lang);
      return response.data; // Adjust according to your actual API response
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Async thunk to fetch featured products
export const fetchNewArrivalProducts = createAsyncThunk(
  "product/fetchNewArrivalProducts",
  async ({ lang }, { rejectWithValue }) => {
    try {
      const response = await NewArrivalServices(lang);
      return response.data; // Adjust according to your actual API response
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Async thunk to fetch featured products
export const fetchSpecificProducts = createAsyncThunk(
  "product/fetchSpecificProducts",
  async ({ lang }, { rejectWithValue }) => {
    try {
      const response = await SpecificProductsServices(lang);
      return response.data; // Adjust according to your actual API response
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchRelatedProducts = createAsyncThunk(
  "product/fetchRelatedProducts",
  async ({ category_id, lang }, { rejectWithValue }) => {
    try {
      const bodyData = { category_id }; // build request body

      const response = await fetchRelatedProductsServices(lang, bodyData);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Define the initial state
const initialState = {
  product: null,
  NewArrival: null,
  RelatedProducts: null,
  SpecificProducts: null,
  loading: false,
  error: null,
};

// Create slice
const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.product = action.payload.data; // Make sure action.payload contains valid product data
      })
      .addCase(fetchProductDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchNewArrivalProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNewArrivalProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.NewArrival = action.payload.data; // Make sure action.payload contains valid product data
      })
      .addCase(fetchNewArrivalProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchSpecificProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSpecificProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.SpecificProducts = action.payload.data; // Make sure action.payload contains valid product data
      })
      .addCase(fetchSpecificProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchRelatedProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRelatedProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.RelatedProducts = action.payload.data; // Make sure action.payload contains valid product data
      })
      .addCase(fetchRelatedProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default productSlice.reducer;
